import React from 'react';
import PropTypes from 'prop-types';

import { Stack } from '@metarouter-private/mr-mui';
import { isPlaybookDisabled } from '@ion/api';
import TextCell from 'app/components/data-table/TextCell';
import RevisionDisabledNote from './RevisionDisabledNote';

const NO_NOTES = 'No revision notes provided.';

export default function RevisionNotesCell({ playbook }) {
  return (
    <Stack spacing={0.5}>
      <TextCell text={playbook.commitMessage ?? NO_NOTES} />
      {isPlaybookDisabled(playbook) && <RevisionDisabledNote playbook={playbook} />}
    </Stack>
  );
}

RevisionNotesCell.propTypes = {
  playbook: PropTypes.shape({
    commitMessage: PropTypes.string,
    disabledAt: PropTypes.string,
  }).isRequired,
};
